import Grid from '@mui/material/Grid';
import { auth, useAuthState } from 'api/services/firebase';
import Loading from 'components/system/Loading';
import UserSettings from './UserSettings';

const AccountSettings = () => {
  const [, loading] = useAuthState(auth);

  return (
    <Grid container sx={{ padding: 0 }}>
      <Grid item xs={12} md={8}>
        {
          loading
            ? <Loading />
            : <UserSettings />
        }
      </Grid>
    </Grid>
  );
};

export default AccountSettings;
